import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_ds_get_warehousesService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseName?: string }): 
  Promise<{ result: { Id?: number, Name?: string, TimeZoneId?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/app/datasources/ds_get_warehouses/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseName?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, TimeZoneId?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/app/datasources/ds_get_warehouses/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseName?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, TimeZoneId?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/app/datasources/ds_get_warehouses/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

